import { render, staticRenderFns } from "./EventBackdrop.vue?vue&type=template&id=58800d9a&scoped=true"
import script from "./EventBackdrop.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventBackdrop.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventBackdrop.vue?vue&type=style&index=0&id=58800d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58800d9a",
  null
  
)

export default component.exports